import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    Button,
    useDisclosure,
} from "@chakra-ui/react";
import { useRef, useState } from "react";

interface AlertProps {
    isOpen: boolean;
    onClose: () => void;
    message: string;
    title?: string;
}

export function useAlert() {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [message, setMessage] = useState("");

    const showAlert = (nextMessage: string) => {
        setMessage(nextMessage);
        onOpen();
    };

    return {
        showAlert,
        alertProps: {
            isOpen,
            onClose,
            message,
        },
    };
}

export default function Alert({ isOpen, onClose, message, title = "알림" }: AlertProps) {
    
    const cancelRef = useRef<HTMLButtonElement>(null);

    return (
        <AlertDialog
            isOpen={isOpen}
            leastDestructiveRef={cancelRef}
            onClose={onClose}
        >
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize={18} fontWeight={700}>
                        {title}
                    </AlertDialogHeader>
                    <AlertDialogBody fontSize={16} fontWeight={400}>
                        {message}
                    </AlertDialogBody>
                    <AlertDialogFooter>
                        <Button ref={cancelRef} onClick={onClose}>
                            확인
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    );
}
